import { useRef, useState } from 'react'
import { Login } from 'components/login/Login'
import { useValidation } from 'hooks/useValidation'
import { useFetch } from 'services/useFetch'
import { API } from 'services/api'
import { Alert } from 'avo-ui'
import { LOGIN_VALIDATION } from 'services/validation/loginValidation'

const INIT_STATE = {
    email: null,
    password: null,
    recaptcha_token: null,
}

export const LoginContainer = () => {
    const recaptchaRef = useRef()
    const [verificationModal, setVerificationModal] = useState(false)
    const [loginDetail, setLoginDetail] = useState(INIT_STATE)
    const { fetching: postLogin, isLoading } = useFetch(API.LOGIN)
    const { validateForm, errorForm, clearErrorForm } = useValidation({
        form: loginDetail,
        schema: LOGIN_VALIDATION,
    })

    const setShowVerificationModal = (value) => {
        setVerificationModal(value)
    }

    const setValueCaptcha = (value) => {
        setLoginDetail({ ...loginDetail, recaptcha_token: value })
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setLoginDetail({ ...loginDetail, [name]: value })
    }

    const onSubmit = () => {
        validateForm().then(() => {
            clearErrorForm()
            postLogin(loginDetail)
                .then(() => setShowVerificationModal(true))
                .catch(() => {
                    setValueCaptcha(null)
                    recaptchaRef?.current?.reset()
                    return Alert({
                        icon: 'error',
                        title: 'Authentication Error !',
                        message: 'Data yang di inputkan tidak valid',
                    })
                })
        })
    }

    const props = {
        verificationModal,
        setShowVerificationModal,
        recaptchaRef,
        loginDetail,
        setValueCaptcha,
        onChangeForm,
        errorForm,
        isLoading,
        onSubmit,
    }

    return <Login {...props} />
}
